import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AspPaymentsCollectionsService } from './asp-payments-collections.service';
import { ToastrService } from 'ngx-toastr';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { NgForm } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

interface FilterOption {
  label: string;
  value: string;
  checked: boolean;
  children?: FilterOption[];
}

interface Filters {
  amountRange: FilterOption[];
  invoiceDate: FilterOption[];
   creditNoteDate: FilterOption[];
  dueByDays: FilterOption[];  // radio-style
  creditNoteNumbers: FilterOption[];
  invoiceNumbers: {
    credit: { label: string; value: string; checked: boolean; }[];
    pending: FilterOption[];
    paid: FilterOption[];
    history: FilterOption[];
  };
  paidOnDate: FilterOption[];
 

}
type InvoiceTabKey = 'pending' | 'paid' | 'history';


@Component({
  selector: 'app-asp-payments-collections',
  templateUrl: './asp-payments-collections.component.html',
  styleUrls: ['./asp-payments-collections.component.scss']
})
export class AspPaymentsCollectionsComponent implements OnInit {
  selectedTab: string= "pending";
  paymentList: any;
  paidPaymentList: any;
  pendingAmount: any;
  paidAmount: any;
  historyList: any;
  historyAmount: any;
  searchText: any='';
  openSideShow: boolean;
  selectedInvoiceIndex: number | null = null;
  paymentLink: any;
  bootomOpen: boolean;
  amount: any;
  roleType: string;
  successIcon: any = '../../../../assets/icons/icons8-ok.gif';
activeBreakdownIndex: number | null = null;
selectAll: boolean = false;
selectedCount = 0;
showBreakdown: { [key: string]: boolean } = {};
paymentTitle: string = 'Quick Pay';
isInputVisible = false;



  
  filters: Filters = {
  amountRange: [
    { label: '₹0 – ₹499', value: '0-499', checked: false },
    { label: '₹500 – ₹999', value: '500-999', checked: false },
    { label: '₹1000 – ₹1999', value: '1000-1999', checked: false },
    { label: '₹2000 – ₹2999', value: '2000-2999', checked: false },
    { label: '₹3000 – ₹3999', value: '3000-3999', checked: false },
    { label: '₹4000 – ₹4999', value: '4000-4999', checked: false },
    { label: '₹5000 & Above', value: '5000+', checked: false }
  ],
  invoiceDate: [
    { label: 'Today', value: 'TODAY', checked: false },
    { label: 'Yesterday', value: 'YESTERDAY', checked: false },
    { label: 'This Week', value: 'THIS_WEEK', checked: false },
    { label: 'Last Week', value: 'LAST_WEEK', checked: false },
    { label: 'This Month', value: 'THIS_MONTH', checked: false },
    { label: 'Last Month', value: 'LAST_MONTH', checked: false }
  ],
    creditNoteDate: [
    { label: 'Today', value: 'TODAY', checked: false },
    { label: 'Yesterday', value: 'YESTERDAY', checked: false },
    { label: 'This Week', value: 'THIS_WEEK', checked: false },
    { label: 'Last Week', value: 'LAST_WEEK', checked: false },
    { label: 'This Month', value: 'THIS_MONTH', checked: false },
    { label: 'Last Month', value: 'LAST_MONTH', checked: false }
  ],
  dueByDays: [
    { label: 'Less than 7 days', value: 'LT7', checked: false },
    { label: 'More than 7 days', value: 'GT7', checked: false },
    { label: 'Less than 1 month', value: 'LT30', checked: false },
    { label: 'More than 1 month', value: 'GT30', checked: false }
  ],
  invoiceNumbers: {
    pending: [],
    paid: [],
    history: [],
    credit: []
  },  
  creditNoteNumbers: [],

   paidOnDate: [ 
    { label: 'Today', value: 'TODAY', checked: false },
    { label: 'Yesterday', value: 'YESTERDAY', checked: false },
    { label: 'This Week', value: 'THIS_WEEK', checked: false },
    { label: 'Last Week', value: 'LAST_WEEK', checked: false },
    { label: 'This Month', value: 'THIS_MONTH', checked: false },
    { label: 'Last Month', value: 'LAST_MONTH', checked: false }
  ]
};
  amt: any;
  paidDates: Date;
@ViewChild('paymentSheet') paymentSheet!: TemplateRef<any>;
  bottomSheetRef: any;
  openSharePopup: boolean;
  isSidebarOpen: boolean;
  isMobile: boolean;
  creditNoteList: { creditNoteNo: string; amount: number; date: string; invoiceNumbers: string;total :number;}[];
  check: boolean;
  creditNoteNumbers: FilterOption[] = [];
  creditAmount: any;
  avgDaysToPay: number;
  historyData: any;
  shareAmount: number;

  constructor(
    private aspPaymentsCollectionsService:AspPaymentsCollectionsService,
    private toastr: ToastrService,
    private aspLoadingService: AspLoadingService,
    private bottomSheet: MatBottomSheet,
      private breakpointObserver: BreakpointObserver,
  ) {  this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        this.isMobile = result.matches;
      });}

  ngOnInit(): void {
    this.pendingIvoices();
    this.roleType=localStorage.getItem("roleType");
    this.getCreditNotes();
  this.aspPaymentsCollectionsService.getHistory().subscribe(
    res =>{
      this.aspLoadingService.hide();
      this.historyData=res['data'];
      if(res['code']==200){
    let totalDays = 0;
let invoiceCount = 0;

// Loop over each payment
res['data'].forEach(payment => {
  const paymentDate = new Date(payment.date);

  // Loop over each settled invoice in this payment
  payment.responsePaymentSettled.forEach((invoice: any) => {
    const invoiceDate = new Date(invoice.invoiceDate);

    // Calculate difference in days
    const diffInMs = paymentDate.getTime() - invoiceDate.getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // ms to days

    totalDays += diffInDays;
    invoiceCount++;
  });
});

this.avgDaysToPay =invoiceCount > 0 ? Math.round(totalDays / invoiceCount) : 0;
      }
    })
    
  }
  selectTab(tab){
    this.searchText='';
    this.selectedTab=tab;
    this.resetFilters();
    if(this.selectedTab=="pending"){
      this.pendingIvoices();
    }
    if(this.selectedTab=="paid"){
      this.paidIvoices();
    }
    if(this.selectedTab=="history"){
     this.getHistory()
    }
    if (this.selectedTab === 'credit') {
    this.getCreditNotes(); 
  }
  }
  resetFilters() {
  // Reset static filters
  this.filters.amountRange.forEach(f => f.checked = false);
  this.filters.invoiceDate.forEach(f => f.checked = false);
  this.filters.dueByDays.forEach(f => f.checked = false);
  this.filters.paidOnDate.forEach(f => f.checked = false);
  this.filters.creditNoteDate.forEach(f => f.checked = false); 

  // Reset dynamic invoice number filters per tab
 Object.keys(this.filters.invoiceNumbers).forEach(tab => {
  const key = tab as InvoiceTabKey; // ✅ Proper cast
  this.filters.invoiceNumbers[key].forEach(f => {
    f.checked = false;
  });
});


   this.filterInvoices();
}

getSearchPlaceholder(): string {
  if (!this.searchText) {
    return '';
  }

  if (this.selectedTab === 'credit') {
    return 'Search by Credit Note No, Invoice No, or Amount';
  } else if (this.selectedTab === 'pending' || this.selectedTab === 'paid') {
    return 'Search by Registration No, Amount, or Invoice No';
  } else {
    return 'Search by Amount, Payment Mode, Tags';
  }
}

toggleSelection(filterKey: keyof Filters | 'creditNoteNumbers', option: FilterOption) {
  console.log("Toggling:", filterKey, option);

  if (filterKey === 'invoiceNumbers') {
    const tabKey = this.selectedTab as keyof Filters['invoiceNumbers'];
    const filterList = this.filters.invoiceNumbers?.[tabKey];

    if (!filterList) {
      console.warn(`invoiceNumbers list not found for tabKey: ${tabKey}`);
      return;
    }

    const selectedOption = filterList.find(opt => opt.value === option.value);
    if (selectedOption) {
      selectedOption.checked = !selectedOption.checked;
    }
  }

  else if (filterKey === 'creditNoteNumbers') {
    const filterList = this.filters.creditNoteNumbers;

    if (!Array.isArray(filterList)) {
      console.warn('filters.creditNoteNumbers array is missing or invalid.');
      return;
    }

    const selectedOption = filterList.find(opt => opt.value === option.value);
    if (selectedOption) {
      selectedOption.checked = !selectedOption.checked;
    }
  }

  else if (filterKey === 'dueByDays') {
    const list = this.filters[filterKey] as FilterOption[];
    if (!list) return;

    list.forEach(opt => {
      opt.checked = (opt.value === option.value);
    });
  }

  else {
    const filterList = this.filters[filterKey] as FilterOption[];
    if (!filterList) {
      console.warn(`No filter list found for key: ${filterKey}`);
      return;
    }

    const selectedOption = filterList.find(opt => opt.value === option.value);
    if (selectedOption) {
      selectedOption.checked = !selectedOption.checked;
    }
  }

  this.filterInvoices();
}




  filteredResults = [];

  filterInvoices() {
    let baseList: any[] = [];

    if (this.selectedTab === 'pending') {
      baseList = this.paymentList;
    } else if (this.selectedTab === 'paid') {
      baseList = this.paidPaymentList;
    } else if (this.selectedTab === 'history') {
      baseList = this.historyList;
    }
    else if (this.selectedTab === 'credit') {
    baseList = this.creditNoteList; 
  }

    if (!baseList || baseList.length === 0) {
      this.filteredResults = [];
      return;
    }
if (this.selectedTab === 'credit') {
  const creditDateFilters = this.filters.creditNoteDate.filter(f => f.checked).map(f => f.value);
  const amountFilters = this.filters.amountRange.filter(f => f.checked).map(f => f.value);
  const selectedCreditNoteNumbers = this.filters.creditNoteNumbers
    ?.filter(f => f.checked)
    .map(f => f.value) || [];

  const today = new Date();
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - today.getDay());

  const startOfLastWeek = new Date(startOfWeek);
  startOfLastWeek.setDate(startOfWeek.getDate() - 7);

  this.filteredResults = baseList.filter(note => {
    const creditDate = new Date(note.creditDate);
    const totalAmount = parseFloat(note.total || '0');
   const creditNoteNumber = note.creditNoteNumber;

    const matchAmount = amountFilters.length === 0 || amountFilters.some(range => {
      if (range === '0-499') return totalAmount >= 0 && totalAmount <= 499;
      if (range === '500-999') return totalAmount >= 500 && totalAmount <= 999;
      if (range === '1000-1999') return totalAmount >= 1000 && totalAmount <= 1999;
      if (range === '2000-2999') return totalAmount >= 2000 && totalAmount <= 2999;
      if (range === '3000-3999') return totalAmount >= 3000 && totalAmount <= 3999;
      if (range === '4000-4999') return totalAmount >= 4000 && totalAmount <= 4999;
      if (range === '5000+') return totalAmount >= 5000;
      return false;
    });

    const matchDate = creditDateFilters.length === 0 || creditDateFilters.some(date => {
      switch (date) {
        case 'TODAY': return creditDate.toDateString() === today.toDateString();
        case 'YESTERDAY': {
          const y = new Date(today);
          y.setDate(today.getDate() - 1);
          return creditDate.toDateString() === y.toDateString();
        }
        case 'THIS_WEEK': return creditDate >= startOfWeek && creditDate <= today;
        case 'LAST_WEEK': {
          const end = new Date(startOfLastWeek);
          end.setDate(end.getDate() + 6);
          return creditDate >= startOfLastWeek && creditDate <= end;
        }
        case 'THIS_MONTH':
          return creditDate.getMonth() === today.getMonth() && creditDate.getFullYear() === today.getFullYear();
        case 'LAST_MONTH': {
          const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          return creditDate.getMonth() === lastMonth.getMonth() &&
            creditDate.getFullYear() === lastMonth.getFullYear();
        }
        default: return false;
      }
    });

    const matchCreditNoteNumber = selectedCreditNoteNumbers.length === 0 ||
      selectedCreditNoteNumbers.includes(creditNoteNumber);

    return matchAmount && matchDate && matchCreditNoteNumber;
  });

  return;
}



    const amountFilters = this.filters.amountRange.filter(f => f.checked).map(f => f.value);
  const dateFilters =this.filters.invoiceDate.filter(f => f.checked).map(f => f.value)
    const paidDateFilters = this.filters.paidOnDate.filter(f => f.checked).map(f => f.value);
    const dueByValue = this.filters.dueByDays.find(f => f.checked)?.value;
    const selectedInvoiceNumbers = this.filters.invoiceNumbers[this.selectedTab]
    ?.filter(f => f.checked)
    .map(f => f.value) || [];

    // No filters selected
    if (
      amountFilters.length === 0 &&
      dateFilters.length === 0 &&
      paidDateFilters.length === 0 &&
      !dueByValue &&
      selectedInvoiceNumbers.length === 0
    ) {
      this.filteredResults = [...baseList];
      return;
    }

    const today = new Date();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay());

    const startOfLastWeek = new Date(startOfWeek);
    startOfLastWeek.setDate(startOfWeek.getDate() - 7);

    this.filteredResults = baseList.filter(invoice => {
      if (this.selectedTab === 'pending') {
      this.amt = invoice.balance ?? 0;
    } else if (this.selectedTab === 'paid') {
      this.amt = invoice.total ?? 0;
    } else if (this.selectedTab === 'history') {
      this.amt = invoice.amount ?? 0;
    }
    
      const invoiceDate = new Date(invoice.date);

      let matchAmount = amountFilters.length === 0 || amountFilters.some(range => {
        if (range === '0-499') return this.amt >= 0 && this.amt <= 499;
        if (range === '500-999') return this.amt >= 500 && this.amt <= 999;
        if (range === '1000-1999') return this.amt >= 1000 && this.amt <= 1999;
        if (range === '2000-2999') return this.amt >= 2000 && this.amt <= 2999;
        if (range === '3000-3999') return this.amt >= 3000 && this.amt <= 3999;
        if (range === '4000-4999') return this.amt >= 4000 && this.amt <= 4999;
        if (range === '5000+') return this.amt >= 5000;
        return false;
      });

      let matchDate = dateFilters.length === 0 || dateFilters.some(date => {
        switch (date) {
          case 'TODAY': return invoiceDate.toDateString() === today.toDateString();
          case 'YESTERDAY': {
            const y = new Date(today);
            y.setDate(today.getDate() - 1);
            return invoiceDate.toDateString() === y.toDateString();
          }
          case 'THIS_WEEK': return invoiceDate >= startOfWeek && invoiceDate <= today;
          case 'LAST_WEEK': {
            const end = new Date(startOfLastWeek);
            end.setDate(end.getDate() + 6);
            return invoiceDate >= startOfLastWeek && invoiceDate <= end;
          }
          case 'THIS_MONTH':
            return invoiceDate.getMonth() === today.getMonth() && invoiceDate.getFullYear() === today.getFullYear();
          case 'LAST_MONTH': {
            const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            return invoiceDate.getMonth() === lastMonth.getMonth() &&
                  invoiceDate.getFullYear() === lastMonth.getFullYear();
          }
          default: return false;
        }
      });
      if(this.selectedTab === 'paid'){
      this.paidDates=new Date(invoice.lastPaymentDate);
      }
      if(this.selectedTab === 'history'){
      this.paidDates=new Date(invoice.date);
      }
      let paidDate = paidDateFilters.length === 0 || paidDateFilters.some(date => {
        switch (date) {
          case 'TODAY': return this.paidDates.toDateString() === today.toDateString();
          case 'YESTERDAY': {
            const y = new Date(today);
            y.setDate(today.getDate() - 1);
            return this.paidDates.toDateString() === y.toDateString();
          }
          case 'THIS_WEEK': return this.paidDates >= startOfWeek && this.paidDates <= today;
          case 'LAST_WEEK': {
            const end = new Date(startOfLastWeek);
            end.setDate(end.getDate() + 6);
            return this.paidDates >= startOfLastWeek && this.paidDates <= end;
          }
          case 'THIS_MONTH':
            return this.paidDates.getMonth() === today.getMonth() && this.paidDates.getFullYear() === today.getFullYear();
          case 'LAST_MONTH': {
            const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            return this.paidDates.getMonth() === lastMonth.getMonth() &&
                  this.paidDates.getFullYear() === lastMonth.getFullYear();
          }
          default: return false;
        }
      });

      let matchDue = true;
        if (this.selectedTab === 'credit') {
    this.filteredResults = [...baseList]; 
    return;
  }
      if(this.selectedTab === 'pending'){
        if (dueByValue && invoice.dueDate) {
          const days = this.getDueDays(invoice.dueDate);
          if (dueByValue === 'LT7') matchDue = days < 7;
          if (dueByValue === 'GT7') matchDue = days >= 7;
          if (dueByValue === 'LT30') matchDue = days < 30;
          if (dueByValue === 'GT30') matchDue = days >= 30;
        }
      }
      if( this.selectedTab === 'history'){
        if (dueByValue && invoice.date) {
          const days = this.getDueDays(invoice.date);
          if (dueByValue === 'LT7') matchDue = days < 7;
          if (dueByValue === 'GT7') matchDue = days >= 7;
          if (dueByValue === 'LT30') matchDue = days < 30;
          if (dueByValue === 'GT30') matchDue = days >= 30;
        }
      }
        if(this.selectedTab === 'paid'){
        if (dueByValue && invoice.lastPaymentDate && invoice.date) {
          const days = this.getDaysSince(invoice.date,invoice.lastPaymentDate);
          if (dueByValue === 'LT7') matchDue = days < 7;
          if (dueByValue === 'GT7') matchDue = days >= 7;
          if (dueByValue === 'LT30') matchDue = days < 30;
          if (dueByValue === 'GT30') matchDue = days >= 30;
        }
      }

      const invoiceNumbersInRow = (invoice.invoiceNumber || invoice.invoiceNumbers || '')
    .split(',')
    .map(n => n.trim());

  const matchInvoice = selectedInvoiceNumbers.length === 0 ||
    invoiceNumbersInRow.some(n => selectedInvoiceNumbers.includes(n));

      return matchAmount && matchDate && paidDate && matchDue && matchInvoice;
    });
  }
getDueDayColor(payment: any): string {
  if (payment.status === 'overdue') {
    return 'text-red';
  }

  const dueMatch = payment.dueDays.match(/(\d+)/);
  const dueInDays = dueMatch ? parseInt(dueMatch[1], 10) : 0;

  if (dueInDays > 7) {
    return 'text-yellow';
  } else {
    return 'text-green';
  }
}
getPaidDayColor(payment: any): string {
  const days = this.getDaysSince(payment.date, payment.lastPaymentDate);
  return days <= 14 ? 'text-green' : 'text-red';
}
shouldShowOnlyDueDate(payment: any): boolean {
  const days = this.getDaysBetweenDates(payment.date, payment.lastPaymentDate);
  return days >= 14;
}

getDaysBetweenDates(date1: string | Date, date2: string | Date): number {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  const diffTime = Math.abs(d2.getTime() - d1.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

getCreditRemainingColor(payment: any): string {
  return payment.creditRemaining === 0 ? 'text-green' : 'text-yellow';
}


toggleBreakdown(paymentNumber: string): void {
  this.showBreakdown[paymentNumber] = !this.showBreakdown[paymentNumber];
}
getInvoiceNumbersArray(invoiceNumbers: string): string[] {
  return invoiceNumbers ? invoiceNumbers.split(',') : [];
}

getDueDays(lastPaymentDate){
   const today = new Date();
  const lastDate = new Date(lastPaymentDate);
const diffMs =today.getTime() - lastDate.getTime();
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}

  // pendingIvoices(){
  //   this.aspLoadingService.show();
  //   this.aspPaymentsCollectionsService.pendingIvoices().subscribe(
  //     res =>{
  //       this.aspLoadingService.hide();
  //       if(res['code']==200){
  //         this.paymentList=res['data'];
  //         this.pendingAmount = this.paymentList.reduce((sum, item) => sum + item.balance, 0);
  //        this.filteredResults = [...this.paymentList];
  //        this.filters.invoiceNumbers.pending = this.paymentList.map(inv => ({
  //         label: inv.invoiceNumber,
  //         value: inv.invoiceNumber,
  //         checked: false
  //       }));
  //       this.filterInvoices();
  //       this.cleanInvoiceNumbers();
  //       }
  //   })
  // }
pendingIvoices() {
  this.aspLoadingService.show();
  this.aspPaymentsCollectionsService.pendingIvoices().subscribe(res => {
    this.aspLoadingService.hide();

    if (res['code'] === 200) {
      this.paymentList = res['data'].map(item => {
        const creditNotesArray = Array.isArray(item.creditNotes) ? item.creditNotes : [];

        // Calculate total of all credit notes for this invoice
        const creditNoteTotal = creditNotesArray.reduce((sum, note) => {
          return sum + Number(note.creditNoteTotal || 0);
        }, 0);

        const total = Number(item.total || 0);
        const totalPaymentDueAmount = total - creditNoteTotal;

        return {
          ...item,
          creditNoteTotal: creditNoteTotal, // fallback to 0 guaranteed
          totalPaymentDueAmount: totalPaymentDueAmount
        };
      });

      // Still update this like before
      this.pendingAmount = this.paymentList.reduce((sum, item) => sum + item.balance, 0);
      this.filteredResults = [...this.paymentList];
      this.filters.invoiceNumbers.pending = this.paymentList.map(inv => ({
        label: inv.invoiceNumber,
        value: inv.invoiceNumber,
        checked: false
      }));

      this.filterInvoices();
      this.cleanInvoiceNumbers();
       event.stopPropagation();
      this.searchText = '';
      this.isInputVisible = false;
    }
  });
}


  paidIvoices(){
  this.aspLoadingService.show();
  this.aspPaymentsCollectionsService.paidIvoices().subscribe(
    res =>{
      this.aspLoadingService.hide();
      if(res['code']==200){
        this.paidPaymentList=res['data'];
        this.paidAmount = this.paidPaymentList.reduce((sum, item) => sum + item.total, 0);
      this.filteredResults = [...this.paidPaymentList];
      this.filters.invoiceNumbers.paid = this.paidPaymentList.map(inv => ({
        label: inv.invoiceNumber,
        value: inv.invoiceNumber,
        checked: false
      }));
      this.filterInvoices();
      this.cleanInvoiceNumbers();
      event.stopPropagation();
      this.searchText = '';
      this.isInputVisible = false;
      }
  })
}
getDaysSince(date,lastPaymentDate){
   const today = new Date(date);
  const lastDate = new Date(lastPaymentDate);
const diffMs =lastDate.getTime()- today.getTime();
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}
  getHistory(){
  this.aspLoadingService.show();
  this.aspPaymentsCollectionsService.getHistory().subscribe(
    res =>{
      this.aspLoadingService.hide();
      if(res['code']==200){
        this.historyList=res['data'];
        this.historyAmount = this.historyList.reduce((sum, item) => sum + item.amount, 0);
      this.filteredResults = [...this.historyList];
      this.filters.invoiceNumbers.history = this.historyList
      .filter(inv => inv.invoiceNumbers && inv.invoiceNumbers.trim() !== '')
      .map(inv => ({
        label: inv.invoiceNumbers,
        value: inv.invoiceNumbers,
        checked: false
      }));

      this.filterInvoices();
      
        this.cleanInvoiceNumbers();
         event.stopPropagation();
      this.searchText = '';
      this.isInputVisible = false;
      }
  })
}

getCreditNotes() {
  this.aspLoadingService.show();
  this.aspPaymentsCollectionsService.getCreditNotes().subscribe({
    next: (res: any) => {
      this.aspLoadingService.hide();
      if (res?.code === 200 && res?.data?.creditNotes?.length) {
          this.creditNoteList = res.data.creditNotes;
          console.log("=================creditnotelist",this.creditNoteList)
          this.creditAmount = this.creditNoteList.reduce(  (sum, item) => sum + (+item.total || 0),   0);
          console.log("================credit amount========================",this.creditAmount);
          const res1 = res.data.creditNotes;
          this.filteredResults = res1;
          console.log("this.filteredResults----",this.filteredResults);
      this.filters.creditNoteNumbers = this.filteredResults.map(note => ({
        label: note.creditNoteNumber,
        value: note.creditNoteNumber,
        checked: false
      }));
          

        console.log("shcjhdsbcsd",this.creditNoteNumbers);
          this.filterInvoices();
           event.stopPropagation();
      this.searchText = '';
      this.isInputVisible = false;
      } else {
        this.creditNoteList = [];
      }
    },
    error: (err) => {
      this.aspLoadingService.hide();
      console.error('Error fetching credit notes:', err);
    }
  });
}
getItemDescriptions(credit: any): string {
  return credit.items?.map(item => item.itemAndDescription).join(', ') || '';
}


// get filteredInvoices() {
//   if (!this.filteredResults) return [];
//     const search = this.searchText.trim().toLowerCase();
//    if (this.selectedTab === 'pending'||this.selectedTab === 'paid') {
//   return this.searchText.trim()
//     ? this.filteredResults.filter(invoice =>
//         invoice.invoiceNumber?.toLowerCase().includes(this.searchText.trim().toLowerCase())
//       )
//     : this.filteredResults;
//   }
//   if (this.selectedTab === 'history') {
//     return this.searchText.trim()
//     ? this.filteredResults.filter(invoice =>
//           invoice.invoiceNumbers?.toLowerCase().includes(this.searchText.trim().toLowerCase())
//         )
//       : this.filteredResults;
//   }
//    if (this.selectedTab === 'credit') {
//     return search
//       ? this.filteredResults.filter(note =>
//           note.creditNoteNumber?.toLowerCase().includes(search) ||
//           note.invoiceNumber?.toLowerCase().includes(search) ||
//           note.amount?.toString().includes(search)
//         )
//       : this.filteredResults;
//   }

//   return this.filteredResults;
// }
get filteredInvoices() {
  if (!this.filteredResults) return [];

  const search = this.searchText.trim().toLowerCase();

  if (this.selectedTab === 'pending') {
    return search
      ? this.filteredResults.filter(invoice =>
          invoice.invoiceNumber?.toLowerCase().includes(search) ||
          invoice.registrationNumber?.toLowerCase().includes(search) ||
          invoice.balance?.toString().includes(search)
        )
      : this.filteredResults;
  }

  if (this.selectedTab === 'paid') {
    return search
      ? this.filteredResults.filter(invoice =>
          invoice.invoiceNumber?.toLowerCase().includes(search) ||
          invoice.registrationNumber?.toLowerCase().includes(search) ||
          invoice.total?.toString().includes(search)
        )
      : this.filteredResults;
  }

  if (this.selectedTab === 'history') {
    return search
      ? this.filteredResults.filter(payment =>
          payment.amount?.toString().includes(search) ||
          payment?.paymentMode?.toLowerCase().includes(search) ||
          payment?.tag?.toLowerCase().includes(search)
        )
      : this.filteredResults;
  }

  if (this.selectedTab === 'credit') {
    return search
      ? this.filteredResults.filter(credit =>
          credit.creditNoteNumber?.toLowerCase().includes(search) ||
          credit.invoiceNumber?.toLowerCase().includes(search) ||
          credit.total ?.toString().includes(search)
        )
      : this.filteredResults;
  }
  console.log("this.filteredResults------",this.filteredResults);

  return this.filteredResults;
}



  sideShow(event: MouseEvent, index: number): void{
     event.stopPropagation(); // Prevent bubbling up
    this.selectedInvoiceIndex = this.selectedInvoiceIndex === index ? null : index;
    this.openSideShow=true;
  }
  openInvoiceUrl(invoiceUrl): void {
    if (invoiceUrl) {
      window.open(invoiceUrl, '_blank');
    } else {
      this.toastr.error('Invoice URL is not available');
    }
  }
viewCreditNote(credit: any): void {
  if (credit.creditNoteUrl) {
    window.open(credit.creditNoteUrl, '_blank');
  } else {
    this.aspPaymentsCollectionsService.createCreditNoteUrl(credit.creditNoteId, credit.creditNoteNumber)
      .subscribe({
        next: (res) => {
          if (res?.code === 200 && res?.data?.length > 0 && res.data[0].pdfUrl) {
            const url = res.data[0].pdfUrl;
            credit.creditNoteUrl = url; // Save url to avoid future API calls
            window.open(url, '_blank');
          } else {
            this.toastr.error('Credit Note URL could not be generated');
          }
        },
        error: () => {
          this.toastr.error('Error creating Credit Note URL');
        }
      });
  }
}

downloadCreditNote(payment: any): void {
  // Case: creditNotes empty but creditNoteIdAndNumber has data → hit API
  if ((payment.creditNotes?.length ?? 0) === 0 && payment.creditNoteIdAndNumber?.length > 0) {
    const { creditNoteId, creditNoteNumber } = payment.creditNoteIdAndNumber[0];
    this.aspPaymentsCollectionsService.createCreditNoteUrl(creditNoteId, creditNoteNumber)
      .subscribe({
        next: (res) => {
          if (res?.code === 200 && res?.data?.length > 0) {
            const url = res.data[0].pdfUrl;
            payment.creditNotes = [{ creditNoteUrl: url }];
            window.open(url, '_blank');
          } else {
            this.toastr.error('Could not generate credit note URL');
          }
        },
        error: () => this.toastr.error('Error generating credit note URL')
      });
    return;
  }

  // Case: already has creditNotes → open it
  if (payment.creditNotes?.length > 0 && payment.creditNotes[0]?.creditNoteUrl) {
    window.open(payment.creditNotes[0].creditNoteUrl, '_blank');
    return;
  }

  this.toastr.warning('No credit note available for this payment');
}


  closePopup(){
    this.openSideShow=false;
  }
  shareOnWhatsApp(payment) {
    const garageName = localStorage.getItem('spareSelectedGarageName');
    const paymentsArray = [payment];
    this.aspLoadingService.show();
    this.aspPaymentsCollectionsService.createPaymentLink(paymentsArray,false,true,this.check).subscribe(res => {
    this.aspLoadingService.hide();
    this.paymentLink=res['data'].paymentLink;
    const message = `*Hi ${garageName}*,
Hope you're doing well.

This is a reminder to clear the payment of *₹${payment.balance.toFixed(2)}* for *Invoice #${payment.invoiceNumber}*. The parts have already been delivered.

Please use the link below to complete the payment at the earliest:
${this.paymentLink}

Thank you for your prompt attention.
*– Team Autoverse*`;

    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  });
  }

  shareSelectedInvoices() {
    const selectedPayments = this.filteredInvoices.filter(p => p.selected);
    this.aspLoadingService.show();
    this.aspPaymentsCollectionsService.createPaymentLink(selectedPayments,false,true,this.check).subscribe(res => {
      this.aspLoadingService.hide();
      this.paymentLink=res['data'].paymentLink;

    const garageName = localStorage.getItem('spareSelectedGarageName') || 'Customer';
    // const amount = selectedPayments.reduce((total, p) => total + p.balance, 0).toFixed(2);
    const amount = selectedPayments.reduce((total, p) => total + p.balance, 0);

    const invoiceNumbers = selectedPayments.map(p => p.invoiceNumber);
    
    const message = `*Hi ${garageName}*,
Hope you're doing well.

This is a reminder to clear the payment of *₹${amount.toFixed(2)}* for Invoice *#${invoiceNumbers.join(', ')}*. The parts have already been delivered.

Please use the link below to complete the payment at the earliest:
${this.paymentLink}

Thank you for your prompt attention.
*– Team Autoverse*`;

    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    this.filteredInvoices.forEach(payment => {
    payment.selected = false;
    this.bootomOpen=false;
  });
  });
  }

  checkboxChange(payment: any): void {
    if (payment.selected) {
      this.bootomOpen=true;
    }
    const selectedPayments = this.filteredInvoices.filter(p => p.selected);
    this.amount = selectedPayments.reduce((total, inv) => total + inv.balance, 0);
    if(this.amount==0){
      this.bootomOpen=false;
    }

    this.selectAll = this.filteredInvoices.every(p => p.selected);
  this.recalculateAmount();

  }
  
  proceedToPay() {
    const selectedPayments = this.filteredInvoices.filter(p => p.selected);
    this.aspLoadingService.show();
    this.aspPaymentsCollectionsService.createPaymentLink(selectedPayments,false,true,this.check).subscribe(res => {
      this.aspLoadingService.hide();
      this.paymentLink=res['data'].paymentLink;
      window.open(this.paymentLink, '_blank');
      this.filteredInvoices.forEach(payment => {
      payment.selected = false;
      this.bootomOpen=false;
    });
    });
  }
  closeSearch(){
    this.searchText='';
  }
  removeFilter(filter: { value: string; key: keyof Filters }) {
 if (filter.key === 'invoiceNumbers') {
  const tabKey = this.selectedTab as InvoiceTabKey;
  const target = this.filters.invoiceNumbers[tabKey].find(f => f.value === filter.value);
  if (target) {
    target.checked = false;
  }
  } else {
    const list = this.filters[filter.key] as FilterOption[];
    const target = list.find(f => f.value === filter.value);
    if (target) target.checked = false;
  }

  this.filterInvoices();
}
get selectedFilters(): { label: string; value: string; key: keyof Filters }[] {
  const filters: { label: string; value: string; key: keyof Filters }[] = [];

  const addSelected = (list: FilterOption[], key: keyof Filters) => {
    list.forEach(opt => {
      if (opt.checked) {
        filters.push({ label: opt.label, value: opt.value, key });
      }
    });
  };

  // Static filters
  addSelected(this.filters.amountRange, 'amountRange');
  addSelected(this.filters.invoiceDate, 'invoiceDate');
  addSelected(this.filters.paidOnDate, 'paidOnDate');
  addSelected(this.filters.dueByDays, 'dueByDays');
  addSelected(this.filters.creditNoteDate, 'creditNoteDate' );
  addSelected(this.filters.creditNoteNumbers, 'creditNoteNumbers' );

  // Invoice numbers per tab
  const tabKey = this.selectedTab as InvoiceTabKey;
this.filters.invoiceNumbers[tabKey].forEach(opt => {
  if (opt.checked) {
    filters.push({ label: opt.label, value: opt.value, key: 'invoiceNumbers' });
  }
});

  return filters;
}
// openBottomSheet(): void {
//     this.bottomSheetRef=this.bottomSheet.open(this.paymentSheet,{
//       panelClass: 'payment-bottom-sheet'
//     });
//   }
  openBottomSheet(title: string,check:boolean): void {
  this.paymentTitle = title;
  this.check = check;
  console.log("this.check-----",this.check);
  this.bottomSheetRef = this.bottomSheet.open(this.paymentSheet, {
    panelClass: 'payment-bottom-sheet',
  });
}
  @ViewChild('formRef') formRef!: NgForm;

  paymentAmount: number | null = null;
  description: string = '';

validateAmount(): void {
  if (this.paymentAmount !== null) {

    if (this.paymentAmount <= 0) {
      this.formRef.controls['paymentAmount'].setErrors({ min: true });
    } else if ((this.paymentAmount > this.pendingAmount.toFixed(2))) {
      this.formRef.controls['paymentAmount'].setErrors({ max: true });
    } else {
      this.formRef.controls['paymentAmount'].setErrors(null);
    }
  }
}


 submitPayment(form: NgForm): void {
  if (!form.valid) {
    form.control.markAllAsTouched(); // 🔹 Mark all fields as touched to show validation errors
    console.log('Form Invalid. Error:', form.controls['paymentAmount']?.errors);
    return;
  }
  else{
    const paymentData = {
      amount: this.paymentAmount,
      description: this.description
    };
    console.log('Submitting payment data:', paymentData);
    // TODO: Call your payment API or logic here
    const invoice = {
      balance: this.paymentAmount,
      invoiceId: '',
      invoiceNumber: this.description
    };
    this.shareAmount=this.paymentAmount;
    this.aspPaymentsCollectionsService.createPaymentLink([invoice],true,false,this.check).subscribe(response => {
      // console.log('Payment link created with fake invoice:', response);
      if(response['code']==200){
      this.paymentLink=response['data'].paymentLink;
      if(this.roleType=='autoverse_employee'){
      this.openSharePopup=true;
      this.closeBottomSheet();
      form.reset();
      }
      else{
        window.open(this.paymentLink, '_blank');
      this.closeBottomSheet();
      form.reset();
      }
    }
    else {
       this.closeBottomSheet();
      form.reset();
      this.toastr.error(response['data'].description);
    }
    });
  }
 }
 closeBottomSheet(): void {
  if (this.bottomSheetRef) {
    this.bottomSheetRef.dismiss();
  }
}
viewDueDetails(payment: any, index: number): void {
  if (this.activeBreakdownIndex === index) {
    this.activeBreakdownIndex = null;
  } else {
    this.activeBreakdownIndex = index;
  }
}
setBreakdownIndex(index: number): void {
  this.activeBreakdownIndex = index;
}

copyLink() {
    navigator.clipboard.writeText(this.paymentLink).then(() => {
      this.toastr.success('Link copied to clipboard!')
    });
  }
//   shareLink(){
//     const garageName = localStorage.getItem('spareSelectedGarageName');
//     const message = `*Hi ${garageName}*,

// Hope you're doing well.

// Your current outstanding balance is *₹${this.pendingAmount.toFixed()}*.
// You can use the link below to make a payment of *₹${this.paymentAmount}* towards it:
// 🔗 ${this.paymentLink}

// The parts have already been delivered.

// We’d really appreciate it if you could settle this at the earliest.

// Thank you for your prompt attention.

// *– Team Autoverse*`;

//  const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
//     window.open(whatsappUrl, '_blank');
    
//       this.openSharePopup=false;

//   }

shareLink() {
  const garageName = localStorage.getItem('spareSelectedGarageName') || 'Customer';

  let message: string;

  if (this.check === false) {
    message = `*Hi ${garageName}*,\n\nHope you're doing well.\n\nYour current outstanding balance is *₹${this.pendingAmount.toFixed()}*.\nYou can use the link below to make a payment of *₹${this.shareAmount}* towards it:\n🔗 ${this.paymentLink}\n\nThe parts have already been delivered.\n\nWe’d really appreciate it if you could settle this at the earliest.\n\nThank you for your prompt attention.\n\n*– Team Autoverse*`;
  } else {
    message = `*Hi ${garageName}*,\n\nHope you’re doing well.\n\nWe’re collecting an *advance payment* of *₹${this.shareAmount}* for your Autoverse account.\nPlease use the link below to pay:\n🔗 ${this.paymentLink}\n\nThis amount will be kept as credit in your account and can be used for your upcoming orders anytime.\n\nThank you for your quick action.\n\n– *Team Autoverse*`;
  }

  const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank');

  this.openSharePopup = false;
}




  closePopUp(){
      this.openSharePopup=false;
  }
cleanInvoiceNumbers() {
  const invoiceTabs: InvoiceTabKey[] = ['pending', 'paid', 'history'];

  invoiceTabs.forEach(tabKey => {
    const invoiceNumbers = this.filters.invoiceNumbers[tabKey];

    if (invoiceNumbers && invoiceNumbers.length) {
      const uniqueInvoiceMap = new Map<string, boolean>();

      invoiceNumbers.forEach(option => {
        const splitLabels = option.label.split(',');
        splitLabels.forEach(label => {
          const trimmedLabel = label.trim();
          if (uniqueInvoiceMap.has(trimmedLabel)) {
            const alreadyChecked = uniqueInvoiceMap.get(trimmedLabel);
            uniqueInvoiceMap.set(trimmedLabel, alreadyChecked || option.checked);
          } else {
            uniqueInvoiceMap.set(trimmedLabel, option.checked);
          }
        });
      });

      // assign back
      this.filters.invoiceNumbers[tabKey] = Array.from(uniqueInvoiceMap).map(([label, checked]) => ({
        label,
        value: label,
        checked
      }));
    }
  });
}

formatInvoiceNumbers(invoiceNumbers: string): string {
  return invoiceNumbers?.replace(/,/g, ', ') ?? '';
}
 sidecontainer() {
    this.isSidebarOpen = !this.isSidebarOpen; // Toggle the sidebar open/close state
  }

clearBreakdownIndex(index: number): void {
  if (this.activeBreakdownIndex === index) {
    this.activeBreakdownIndex = null;
  }
}
toggleSelectAll(): void {
  this.filteredInvoices.forEach(payment => {
    payment.selected = this.selectAll;
  });
  this.recalculateAmount();
}


recalculateAmount(): void {
  const selectedPayments = this.filteredInvoices.filter(p => p.selected);
  this.amount = selectedPayments.reduce((total, inv) => total + inv.balance, 0);
  this.selectedCount = selectedPayments.length; // ✅ Add this line
  this.bootomOpen = this.amount > 0;
}

    toggleSearch() {
        this.isInputVisible = !this.isInputVisible;
        if (this.isInputVisible) {
          setTimeout(() => {
            const input = document.querySelector('.SearchInput') as HTMLInputElement;
            if (input) {
              input.focus();
            }
          }, 0);
        }
      }

  clearSearch(event: Event): void {
  event.stopPropagation();
  this.searchText = '';
  this.isInputVisible = false;
}

parseDateString(dateStr: string): Date {
  const [day, month, year] = dateStr.split('/');
  return new Date(+year, +month - 1, +day);
}

}